import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/theme-dawn";
import Toggle from "@atlaskit/toggle";
import { Label } from "@atlaskit/form";
import { setEditorSaved } from "../../../../../../redux/actions/integrationActions";
import { getAceEditorTheme } from "../../../../../../common/utils/aceEditorTheme";
import sampleTransformationScript from "./sampleTransformationScript";

const ResponseTransformation = ({ action, updateCallback }) => {
  const [enabled, setEnabled] = useState(false);
  const [script, setScript] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    const transformation = action?.responseOpt?.transformation;
    setEnabled(transformation?.enabled === true);
    setScript(transformation?.script ?? "");
  }, [action]);

  const ensureResponseOpt = () => {
    if (!action) {
      return null;
    }
    if (!action.responseOpt) {
      action.responseOpt = {};
    }
    return action.responseOpt;
  };

  const ensureTransformation = () => {
    const responseOpt = ensureResponseOpt();
    if (!responseOpt) {
      return null;
    }
    if (!responseOpt.transformation) {
      responseOpt.transformation = { enabled: false };
    }
    return responseOpt.transformation;
  };

  const onToggle = () => {
    const transformation = ensureTransformation();
    if (!transformation) {
      return;
    }
    const nextEnabled = !enabled;
    const nextScript = nextEnabled && !script ? sampleTransformationScript : script;
    transformation.enabled = nextEnabled;
    transformation.script = nextScript;
    setScript(nextScript);
    setEnabled(nextEnabled);
    updateCallback?.();
  };

  const onScriptChange = (value) => {
    setScript(value);
    const transformation = ensureTransformation();
    if (!transformation) {
      return;
    }
    transformation.script = value;
    updateCallback?.();
    dispatch(setEditorSaved(false));
  };

  return (
    <div className="ihub-response-transformation">
      <div className="ihub-response-file-toggle">
        <Toggle id="response-transformation-toggle" size="regular" isChecked={enabled} onChange={onToggle} />
        <span style={{ position: "relative", top: "-4px" }}>Transform response data using script</span>
      </div>
      {enabled && (
        <>
          <p className="ihub-action-tab-description">
            Execute a JavaScript snippet to reshape the HTTP response data before it is stored or shared with downstream actions.
          </p>
          <Label htmlFor="response-transformation-script">Script</Label>
          <AceEditor
            id="response-transformation-script"
            mode="javascript"
            theme={getAceEditorTheme()}
            name="response-transformation-script"
            value={script}
            onChange={onScriptChange}
            editorProps={{ $blockScrolling: true }}
            width="100%"
            height="220px"
            showPrintMargin={false}
          />
          <span className="ihub-action-tab-description">
            The script must explicitly return the value you want to keep. Access the response data via <code>contex?.data</code>.
          </span>
          <p className="ihub-action-tab-description">
            `Example: <code>return context?.data?.items?.filter(item =&gt; item.status === "open");`</code>
          </p>
        </>
      )}
    </div>
  );
};

export default ResponseTransformation;
